<div class="container mx-6 px-6">
  <article>
    <section class="section is-justify-content-left pb-1">
      <h1>An error has occurred</h1>
    </section>
    <div class="columns mx-5 mb-6">
      <div class="column is-12 is-justify-content-left">
        <article class="ukho-notification">
          <div>
            <p>An error has occurred, please contact customer services:</p>
            <p><a [href]="'mailto:customerservices@ukho.gov.uk?subject=UKHO%20Data%20Upload%20Permissions%20Issue'"><strong>customerservices&#64;ukho.gov.uk</strong></a></p>
          </div>
        </article>
      </div>
    </div>
  </article>
</div>
